import React, { useEffect, useState, useRef } from "react";
import "../../styles/desktop/CampoLuzes.css";
import { LightGroup } from "../Classes/LightGroup";
import Ligado from "../../assets/img/Ligado.png";
import Desligado from "../../assets/img/Desligado.png";
import { getLuzesStatusFlex35, statusDasLuzesFlex35 } from "../../API/FeedBackLuzes";
import { acionarAll } from "../../API/acionarAll"; // Renomeando a importação para evitar conflito

const GroupLightComponent = () => {
  const groupRefs = useRef({
    grupo01: React.createRef(),
    grupo02: React.createRef(),
    grupo03: React.createRef(),
    grupo05: React.createRef(),
    grupo20: React.createRef(),
    grupo21: React.createRef(),
  });

  const [imageStates, setImageStates] = useState({
    grupo01: false,
    grupo02: false,
    grupo03: false,
    grupo05: false,
    grupo20: false,
    grupo21: false,
  });

  const [loading, setLoading] = useState(true);
  const [acionarAllText, setAcionarAllText] = useState("Ligar");
  const [isBlocked, setIsBlocked] = useState(false); // Estado para bloquear a atualização temporária

  useEffect(() => {
    const fetchData = () => {
      // Só busca dados se não estiver bloqueado
      if (isBlocked) return;

      getLuzesStatusFlex35()
        .then(() => {
          console.log("Feedback de status das luzes:", statusDasLuzesFlex35); // Log do feedback recebido
          updateLightGroup();
          setLoading(false);
        })
        .catch(error => {
          console.error("Erro ao buscar status das luzes:", error);
          setLoading(false); // Para garantir que saia do carregamento mesmo em caso de erro
        });
    };

    fetchData();

    const intervalId = setInterval(fetchData, 3000);

    return () => clearInterval(intervalId);
  }, [isBlocked]);

  const updateLightGroup = () => {
    const updatedImageStates = {
      grupo01: statusDasLuzesFlex35.includes("1R10") && !statusDasLuzesFlex35.includes("1R00"),
      grupo02: statusDasLuzesFlex35.includes("1H10") && !statusDasLuzesFlex35.includes("1H00"),
      grupo03: statusDasLuzesFlex35.includes("1E10") && !statusDasLuzesFlex35.includes("1E00"),
      grupo05: statusDasLuzesFlex35.includes("1C10") && !statusDasLuzesFlex35.includes("1C00"),
      grupo20: statusDasLuzesFlex35.includes("1D10") && !statusDasLuzesFlex35.includes("1D00"),
      grupo21: statusDasLuzesFlex35.includes("1S10") && !statusDasLuzesFlex35.includes("1S00"),
    };

    setImageStates(updatedImageStates);

    // Verifica se todas as luzes estão ligadas para definir o texto do botão
    const todasLuzesLigadas = Object.values(updatedImageStates).every(state => state === true);
    setAcionarAllText(todasLuzesLigadas ? "Desligar" : "Ligar");
  };

  const handleToggleLightGroup = (groupId, newImageState) => {
    setImageStates(prevState => ({ ...prevState, [groupId]: newImageState }));
  };

  const handleAcionarAll = async () => {
    const action = Object.values(imageStates).some(state => state === false);
    const page = 1;

    try {
      const response = await acionarAll(action, page);
      console.log("Resposta do servidor:", response);

      setImageStates(prevStates => {
        const newState = {};
        Object.keys(prevStates).forEach(key => {
          newState[key] = action; // Define todas como "true" (ligadas) ou "false" (desligadas)
        });
        return newState;
      });

      setAcionarAllText(action ? "Desligar" : "Ligar");

      // Bloqueia o uso de fetchData no useEffect por 10 segundos
      setIsBlocked(true);
      setTimeout(() => {
        setIsBlocked(false); // Desbloqueia após 10 segundos
      }, 10000); // 10 segundos em milissegundos

    } catch (error) {
      console.error("Erro ao acionar todas as luzes:", error);
    }
  };

  if (loading) {
    return <div>Carregando...</div>;
  }
  return (
    <>
      <div className="group" id="campoGroup-pagina1">
        {/* Grupo 01 */}
        
          <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo01}
          groupId="grupo01"
          descricao="Postes"
          imageUrl={imageStates.grupo01 ? Ligado : Desligado}
          onCommand="1R10"
          offCommand="1R00"
          x={6.9}
          y={90.5}
          width={2.8}
          height={4.5}
          imageState={imageStates.grupo01}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo01}
          groupId="grupo01"
          descricao="Postes"
          imageUrl={imageStates.grupo01 ? Ligado : Desligado}
          onCommand="1R10"
          offCommand="1R00"
          x={9.1}
          y={76.1}
          width={2.8}
          height={4.5}
          imageState={imageStates.grupo01}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo01}
          groupId="grupo01"
          descricao="Postes"
          imageUrl={imageStates.grupo01 ? Ligado : Desligado}
          onCommand="1R10"
          offCommand="1R00"
          x={10.2}
          y={60.5}
          width={2.8}
          height={4.5}
          imageState={imageStates.grupo01}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo01}
          groupId="grupo01"
          descricao="Postes"
          imageUrl={imageStates.grupo01 ? Ligado : Desligado}
          onCommand="1R10"
          offCommand="1R00"
          x={10.7}
          y={53}
          width={2.8}
          height={4.5}
          imageState={imageStates.grupo01}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo01}
          groupId="grupo01"
          descricao="Postes"
          imageUrl={imageStates.grupo01 ? Ligado : Desligado}
          onCommand="1R10"
          offCommand="1R00"
          x={13.9}
          y={37.4}
          width={2.8}
          height={4.5}
          imageState={imageStates.grupo01}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo01}
          groupId="grupo01"
          descricao="Postes"
          imageUrl={imageStates.grupo01 ? Ligado : Desligado}
          onCommand="1R10"
          offCommand="1R00"
          x={15.1}
          y={28.6}
          width={2.8}
          height={4.5}
          imageState={imageStates.grupo01}
          onToggleLightGroup={handleToggleLightGroup}
        />  

        {/* Grupo 02 */}


        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo02}
          groupId="grupo02"
          descricao="Muro acesso de veículos"
          imageUrl={imageStates.grupo02 ? Ligado : Desligado}
          onCommand="1H10"
          offCommand="1H00"
          x={10.8}
          y={90.5}
          width={2.8}
          height={4.5}
          imageState={imageStates.grupo02}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo02}
          groupId="grupo02"
          descricao="Muro acesso de veículos"
          imageUrl={imageStates.grupo02 ? Ligado : Desligado}
          onCommand="1H10"
          offCommand="1H00"
          x={35.4}
          y={90.5}
          width={2.8}
          height={4.5}
          imageState={imageStates.grupo02}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo02}
          groupId="grupo02"
          descricao="Muro acesso de veículos"
          imageUrl={imageStates.grupo02 ? Ligado : Desligado} 
          onCommand="1H10"
          offCommand="1H00"
          x={28.4}
          y={90.5}
          width={2.8}
          height={4.5}
          imageState={imageStates.grupo02}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo02}
          groupId="grupo02"
          descricao="Muro acesso de veículos"
          imageUrl={imageStates.grupo02 ? Ligado : Desligado} 
          onCommand="1H10"
          offCommand="1H00"
          x={22.3}
          y={90.5}
          width={2.8}
          height={4.5}
          imageState={imageStates.grupo02}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo02}
          groupId="grupo02"
          descricao="Muro acesso de veículos"
          imageUrl={imageStates.grupo02 ? Ligado : Desligado} 
          onCommand="1H10"
          offCommand="1H00"
          x={16.8}
          y={90.5}
          width={2.8}
          height={4.5}
          imageState={imageStates.grupo02}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo02}
          groupId="grupo02"
          descricao="Muro acesso de veículos"
          imageUrl={imageStates.grupo02 ? Ligado : Desligado} 
          onCommand="1H10"
          offCommand="1H00"
          x={16.8}
          y={76.35}
          width={2.8}
          height={4.5}
          imageState={imageStates.grupo02}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo02}
          groupId="grupo02"
          descricao="Muro acesso de veículos"
          imageUrl={imageStates.grupo02 ? Ligado : Desligado} 
          onCommand="1H10"
          offCommand="1H00"
          x={13.5}
          y={64.5}
          width={2.8}
          height={4.5}
          imageState={imageStates.grupo02}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 03 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo03}
          groupId="grupo03"
          descricao="Logo + Led Serviços"
          imageUrl={imageStates.grupo03 ? Ligado : Desligado} 
          onCommand="1E10"
          offCommand="1E00"
          x={14.6}
          y={58.1}
          width={2.8}
          height={4.5}
          imageState={imageStates.grupo03}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo03}
          groupId="grupo03"
          descricao="Logo + Led Serviços"
          imageUrl={imageStates.grupo03 ? Ligado : Desligado} 
          onCommand="1E10"
          offCommand="1E00"
          x={14.5}
          y={50.2}
          width={2.8}
          height={4.5}
          imageState={imageStates.grupo03}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo03}
          groupId="grupo03"
          descricao="Logo + Led Serviços"
          imageUrl={imageStates.grupo03 ? Ligado : Desligado} 
          onCommand="1E10"
          offCommand="1E00"
          x={17.9}
          y={39.3}
          width={2.8}
          height={4.5}
          imageState={imageStates.grupo03}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo03}
          groupId="grupo03"
          descricao="Logo + Led Serviços"
          imageUrl={imageStates.grupo03 ? Ligado : Desligado} 
          onCommand="1E10"
          offCommand="1E00"
          x={18.7}
          y={31}
          width={2.8}
          height={4.5}
          imageState={imageStates.grupo03}
          onToggleLightGroup={handleToggleLightGroup}
        />


        {/* Grupo 05 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo05}
          groupId="grupo05"
          descricao="Iluminação Lixeira"
          imageUrl={imageStates.grupo05 ? Ligado : Desligado}
          onCommand="1C10" //1C10
          offCommand="1C00" //1C00
          x={25.2}
          y={36.1}
          width={2.8}
          height={4.5}
          imageState={imageStates.grupo05}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 20 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo20}
          groupId="grupo20"
          descricao="Pendente Hall Social"
          imageUrl={imageStates.grupo20 ? Ligado : Desligado}
          onCommand="1D10"
          offCommand="1D00"
          x={19.1}
          y={66.5}
          width={2.8}
          height={4.5}
          imageState={imageStates.grupo20}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo20}
          groupId="grupo20"
          descricao="Pendente Hall Social"
          imageUrl={imageStates.grupo20 ? Ligado : Desligado}
          onCommand="1D10"
          offCommand="1D00"
          x={18.7}
          y={46.65}
          width={2.8}
          height={4.5}
          imageState={imageStates.grupo20}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 21 */}

      <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo21}
          groupId="grupo21"
          descricao="Hall Entrada Social"
          imageUrl={imageStates.grupo21 ? Ligado : Desligado}
          onCommand="1S10"
          offCommand="1S00"
          x={27}
          y={62.5}
          width={2.8}
          height={4.5}
          imageState={imageStates.grupo21}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Legenda de acionamentos */}

        <div className="campo-clickable-element">
          <div
            id="clickable-element"
            className="clickable-element"
            onClick={() => {
              handleToggleLightGroup('grupo01', !imageStates.grupo01);
              groupRefs.current.grupo01.current.sendCommand(
                groupRefs.current.grupo01.current.props.descricao,
                imageStates.grupo01 ? groupRefs.current.grupo01.current.props.offCommand : groupRefs.current.grupo01.current.props.onCommand
              );
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo01 ? 'Highlighted' : ''}`}>1</p>
            <p className="textBar">Postes</p>
          </div>
          <div className="clickable-element" onClick={() => {
              handleToggleLightGroup('grupo02', !imageStates.grupo02);
              groupRefs.current.grupo02.current.sendCommand(
                groupRefs.current.grupo02.current.props.descricao,
                imageStates.grupo02 ? groupRefs.current.grupo02.current.props.offCommand : groupRefs.current.grupo02.current.props.onCommand
              );
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo02 ? 'Highlighted' : ''}`}>2</p>
            <p className="textBar">Muro acesso de veículos</p>
          </div>
          <div className="clickable-element" onClick={() => {
              handleToggleLightGroup('grupo03', !imageStates.grupo03);
              groupRefs.current.grupo03.current.sendCommand(
                groupRefs.current.grupo03.current.props.descricao,
                imageStates.grupo03 ? groupRefs.current.grupo03.current.props.offCommand : groupRefs.current.grupo03.current.props.onCommand
              );
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo03 ? 'Highlighted' : ''}`}>3</p>
            <p className="textBar">Logo + Led Serviços</p>
          </div>
          <div className="clickable-element" onClick={() => {
              handleToggleLightGroup('grupo05', !imageStates.grupo05);
              groupRefs.current.grupo05.current.sendCommand(
                groupRefs.current.grupo05.current.props.descricao,
                imageStates.grupo05 ? groupRefs.current.grupo05.current.props.offCommand : groupRefs.current.grupo05.current.props.onCommand
              );
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo05 ? 'Highlighted' : ''}`}>5</p>
            <p className="textBar">Iluminação Lixeira</p>
          </div>
          <div className="clickable-element" onClick={() => {
              handleToggleLightGroup('grupo20', !imageStates.grupo20);
              groupRefs.current.grupo20.current.sendCommand(
                groupRefs.current.grupo20.current.props.descricao,
                imageStates.grupo20 ? groupRefs.current.grupo20.current.props.offCommand : groupRefs.current.grupo20.current.props.onCommand
              );
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo20 ? 'Highlighted' : ''}`}>20</p>
            <p className="textBar">Pendente Hall Social</p>
          </div>
          <div className="clickable-element-last" onClick={() => {
              handleToggleLightGroup('grupo21', !imageStates.grupo21);
              groupRefs.current.grupo21.current.sendCommand(
                groupRefs.current.grupo21.current.props.descricao,
                imageStates.grupo21 ? groupRefs.current.grupo21.current.props.offCommand : groupRefs.current.grupo21.current.props.onCommand
              );
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo21 ? 'Highlighted' : ''}`}>21</p>
            <p className="textBar">Hall Entrada Social</p>
          </div>
        </div>
        <button className={`bntAcionarAll${acionarAllText === 'Desligar' ? '-ativo' : ''}`} onClick={() => {handleAcionarAll()}}>
          {acionarAllText} luzes
        </button>
      </div>
    </>
  );
};

export default React.memo(GroupLightComponent);